<template>
  <a-modal
    :title="title"
    :centered="true"
    :destroyOnClose="true"
    :bodyStyle="{
      height: '75vh',
      padding: '18px',
      overflow: 'auto'
    }"
    :footer="null"
    width="80%"
    v-model:visible="visible"
  >
    <a-spin :spinning="loading">
      <searchOrder
        @searchList="searchList"
        @handleExport="handleExport"
        :mode="curDetailType"
        :baseQuery="query"
        :dateList="dateList"
      />
      <!-- <div class="user-info">
        <span>ERP编号：{{ userInfo.erpId }}</span>
        <span>姓名：{{ userInfo.realName }}</span>
      </div> -->
      <a-table
        class="tableContainer"
        :columns="tableColumn"
        :transformCellText="({ text }) => text ?? '--'"
        :pagination="pagination"
        :data-source="TableData"
        :rowKey="(record, index) => index"
        :scroll="{ x: '100%', y: 'calc(100vh - 330px)' }"
        @change="onChangePage"
      >
        <!-- 优秀案例ID -->
        <template #excellentCaseId="{ record, text: excellentCaseId }">
          <span class="link" @click="caseDetailRef.showCaseDetail(record)">
            {{ excellentCaseId }}
          </span>
        </template>
        <!-- 工单ID -->
        <template #workOrderId="{ record, text: workOrderId }">
          <span class="link" @click="viewWorkOrderDetails(record)">{{ workOrderId }}</span>
        </template>
        <!-- 工单类型 -->
        <template #workOrderType="{ text: workOrderType }">
          {{ handleWorkOrderType(workOrderType) || '--' }}
        </template>
        <!-- 生成时间 -->
        <template #createdAt="{ text: createdAt }">
          {{ momentFormat(createdAt, 'YYYY-MM-DD HH:mm:ss') }}
        </template>
        <!-- 完成时间 -->
        <template #completeTime="{ text: completeTime }">
          {{ momentFormat(completeTime, 'YYYY-MM-DD HH:mm:ss') }}
        </template>
        <!-- 是否达到自动完成条件 -->
        <template #whetherAutoComplete="{ text: whetherAutoComplete }">
          {{ handleAutoCompleteOrTrace(whetherAutoComplete) || '--' }}
        </template>
        <!-- 是否有痕迹 -->
        <template #whetherTrace="{ text: whetherTrace }">
          {{ handleAutoCompleteOrTrace(whetherTrace) || '--' }}
        </template>
        <!-- 满意数 -->
        <template #satisfiedCnt="{ text: satisfiedCnt }">
          {{ handleFormatNumber(satisfiedCnt) }}
        </template>
        <!-- 不满意数 -->
        <template #dissatisfiedCnt="{ text: dissatisfiedCnt }">
          {{ handleFormatNumber(dissatisfiedCnt) }}
        </template>
        <!-- 上传时间 -->
        <template #uploadAt="{ text: uploadAt }">
          {{ momentFormat(uploadAt, 'YYYY-MM-DD HH:mm:ss') }}
        </template>
        <!-- 收益金额 -->
        <template #benefitAmount="{ text: benefitAmount }">
          {{ handleFormatNumber(benefitAmount) }}
        </template>
        <template #businessType="{ text }">{{ handleWorkOrderType(text) || '--' }}</template>
        <!-- 新增医生和患者标签 -->
        <template #reminder="{ record }">
          <div class="reminder z-fixed">
            <div class="flg userFlg z-fixed-c" :style="renderTagClass(record)">
              {{ renderReminder(record) }}
            </div>
            <span>{{ record.reminder || '--' }}</span>
          </div>
        </template>
        <template #workOrderTask="{ record }">
          <div class="beRemindedUser">
            <div class="flg lgFlg z-fixed-c" v-if="record.activityFlag == 1">临观</div>
            <span class="pre" v-if="record.eventId === 'PatientRegisterFillHealthInfo'">
              {{ `${record.ucDoctorName}${record.workOrderTask}` }}
            </span>
            <span class="pre" v-else-if="record.eventId === 'PatientNotEvaluateConsult'">
              {{ `问诊${record.businessId}${record.workOrderTask}` }}
            </span>
            <span v-else class="pre">
              <div
                v-html="brightenKeyword(record)"
                @click="handleDetail(record)"
                :class="{ pointer: record.serialNumber || record.reserveSn }"
              ></div>
            </span>
          </div>
        </template>
        <template #workOrderList="{ text }">
          <template v-if="text?.length">
            <text
              class="link"
              v-for="(it, index) in text"
              :key="index"
              @click="getOrderDetails(it)"
            >
              {{ it }}
              <span v-if="text.length - 1 > index">,</span>
            </text>
          </template>
          <template v-else>--</template>
        </template>
        <template #handle="{ record }">
          <text class="link" @click="viewWorkOrderDetails(record)">详情</text>
        </template>
      </a-table>
    </a-spin>
    <CaseDetail ref="caseDetailRef" :canEdit="false" />
    <PatientInfoDetails
      :showAllDialog="showAllDialog"
      :currentInfo="currentInfo"
      @handleCancel="handleCancel"
    />
    <ADetail ref="aDetail" :reserveSn="reserveSn" />
    <the-detail
      v-model:visible="detail.detailVisible"
      :serialNumber="detail.serialNumber"
      :recordType="detail.recordType"
      :id="detail.id"
      mode="read"
    />
  </a-modal>
</template>

<script setup>
import { ref, defineExpose, defineProps, computed, nextTick, reactive, unref } from 'vue'
import { DetailDriveConfig } from './config'
import { brightenKeyword, subStringToType } from '@/utils/index'
import { handleWorkOrderType, getWorkOrderEventType } from '@/views/hooks/workorderType'
import CaseDetail from '@/views/ExcellentCase/caseDetail.vue'
import PatientInfoDetails from '@/components/PatientInfoDetails'
import TheDetail from '@/components/TheDetail/index.vue'
import ADetail from '@/views/WorkPlace/components/Appoint/index.vue'
import useTableTools from '@/views/hooks/useTableTools'
import searchOrder from './searchOrder.vue'
import { formateDateByMonth, handleFormatNumber, formatDateForFilter } from '@/utils'
import { workOrderDetail } from '@/api/Todo/index.js'
import { momentFormat } from '@/utils/index'
const { TableData, normalizeExport } = useTableTools()
const props = defineProps({
  query: {
    type: Object,
    default: () => {}
  }
})
const paginationConfig = {
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
}
const pagination = reactive({ ...paginationConfig })
const caseDetailRef = ref(null)
const title = ref('')
const visible = ref(false)
const tableColumn = ref([])
const curUcUserId = ref('')
const userInfo = reactive({
  realName: '',
  erpId: ''
})
const curDetailType = ref('')
const loading = ref(false)
let filterQuery = {}
const dateList = ref([])
const getBaseQuery = () => {
  return unref(props.query) || {}
}
const getDateRange = () => {
  const { startDate, endDate } = getBaseQuery()
  if (startDate && endDate) {
    return { startDate, endDate }
  }

  const [todayStart, todayEnd] = formatDateForFilter([new Date(), new Date()], true)
  return {
    startDate: startDate || todayStart,
    endDate: endDate || todayEnd
  }
}
const initdetail = (ctx, record) => {
  filterQuery = {}
  const { uc_user_id, real_name, erp_id } = record
  userInfo.erpId = erp_id
  userInfo.realName = real_name
  //FIXME:弹窗缓存？
  Object.assign(pagination, paginationConfig)
  TableData.value = []
  curDetailType.value = ctx
  const { column, label } = DetailDriveConfig[curDetailType.value]
  title.value = label
  tableColumn.value = column
  curUcUserId.value = uc_user_id
  const { startDate, endDate } = getDateRange()
  if (ctx === 'satisfactionEvaluation') {
    const [start, end] = formateDateByMonth(startDate, endDate)
    filterQuery = {
      evaluateTimeStart: start,
      evaluateTimeEnd: end,
      sortFieldName: 'evaluateTime',
      sortType: 2,
      evaluateStatus: 1
    }
    dateList.value = [start, end]
  } else {
    dateList.value = []
  }
  listQuery()
}
const onlyPatientInfo = computed(() =>
  curDetailType.value ? DetailDriveConfig[curDetailType.value].onlyPatientInfo : true
)

const searchList = query => {
  Object.assign(filterQuery, query)
  pagination.current = paginationConfig.current
  pagination.pageSize = paginationConfig.pageSize
  listQuery()
}
const handleExport = async query => {
  Object.assign(filterQuery, query)
  const params = handleQuery()
  const { exportUrl, label } = DetailDriveConfig[curDetailType.value]
  loading.value = true
  await normalizeExport(exportUrl, { ...params }, label, 'post')
  loading.value = false
}
// 接口请求之前的参数处理
const handleQuery = () => {
  const { startDate, endDate } = getDateRange()
  const params = {
    // ...getBaseQuery(),
    erpId: userInfo.erpId,
    startDate,
    endDate,
    ...filterQuery,
    userId: curUcUserId.value,
    pageNo: pagination.current,
    pageSize: pagination.pageSize
    // ucDoctorAssistantId: curUcUserId.value
  }
  return params
}
// 分页查询
const onChangePage = (page, filters, sorter) => {
  const { field, order } = sorter
  if (field) {
    if (order === 'descend') {
      // 降序
      filterQuery.sortType = 2
      filterQuery.sortFieldName = field
    } else if (order === 'ascend') {
      // 升序
      filterQuery.sortType = 1
      filterQuery.sortFieldName = field
    } else {
      filterQuery.sortType = 2
      filterQuery.sortFieldName = 'evaluateTime'
    }
  }

  pagination.current = page.current
  pagination.pageSize = page.pageSize
  listQuery()
}
const listQuery = () => {
  loading.value = true
  const params = handleQuery()
  const { fetchApi } = DetailDriveConfig[curDetailType.value]
  // 动态接口回显数据
  fetchApi(params)
    .then(res => {
      const { list, totalCount } = res
      pagination.total = totalCount
      pagination.showTotal = () => `共${totalCount}条`
      TableData.value = list
    })
    .finally(() => {
      loading.value = false
    })
}

// 查看工单详情
const showAllDialog = ref(false)
// FIXME: 列表缺少获取ChatHistory参数
const currentInfo = ref({})
const viewWorkOrderDetails = record => {
  showAllDialog.value = true
  record.workOrderId = record.workOrderId + ''
  const WorkOrderEventType = getWorkOrderEventType(record['workOrderTypeName'])
  record['businessType'] = WorkOrderEventType
  currentInfo.value = record
}
const getOrderDetails = workOrderId => {
  workOrderDetail({ workOrderId }).then(res => {
    viewWorkOrderDetails(res.workOrder || {})
  })
}
const handleCancel = () => {
  showAllDialog.value = false
  currentInfo.value = {}
}

const aDetail = ref(null)
const reserveSn = ref('')
const detail = reactive({
  detailVisible: false,
  serialNumber: '',
  recordType: '',
  id: ''
})
const handleDetail = record => {
  const { serialNumber, businessType, reserveSn: reserveId, follUpPlanId } = record
  if (businessType === 7) {
    if (!reserveId) return
    reserveSn.value = reserveId.toString()
    nextTick(() => {
      aDetail.value.mVisible = true
      aDetail.value.initDetail()
    })
  } else if (businessType === 11 || businessType === 12) {
    if (!follUpPlanId) return
    detail.detailVisible = true
    detail.id = follUpPlanId
    detail.recordType = 'visit'
  } else {
    if (!serialNumber) return
    detail.serialNumber = serialNumber
    detail.recordType = subStringToType(serialNumber)
    detail.detailVisible = true
  }
}
// 判断是否达到自动完成条件或者是否有痕迹
const handleAutoCompleteOrTrace = val => {
  return val ? '是' : '否'
}
const renderReminder = record => {
  const { remindedType } = record
  return remindedType === 1 ? '患者' : remindedType === 2 ? '医生' : 'BD'
}

const renderTagClass = record => {
  const { remindedType, reminder } = record
  if (!reminder) return { display: 'none' }
  return {
    background: remindedType === 1 ? '#FFEED9' : remindedType === 2 ? '#D6EAFF' : '#d3f2ec',
    color: remindedType === 1 ? '#FFA940' : remindedType === 2 ? '#1890FF' : '#24bca2'
  }
}

defineExpose({
  visible,
  initdetail
})
</script>
<style lang="scss" scoped>
.user-info {
  margin: 10px 0 20px;
  font-size: 14px;
  span {
    padding-right: 20px;
  }
}
.link {
  cursor: pointer;
  color: #1890ff;
}

.pre {
  color: #333333;
  .pointer {
    cursor: pointer;
  }
}

.beRemindedUser {
  position: relative;
  display: flex;

  .gaoClass {
    position: absolute;
    left: -16px;
    width: 4px;
    height: 22px;
    background: #f84f4f;
  }
}

.lgFlg {
  background: rgba(158, 158, 158, 0.3);
  color: #333333;
  // color: #666666;
  // border: 1px solid rgba(102, 102, 102, 0.6);
  text-align: center;
  font-size: 8px;
  border-radius: 4px;
  width: 30px;
  height: 20px;
  min-width: 30px;
  min-height: 20px;
  margin-right: 2px;
}

.flg {
  position: relative;
  text-align: center;
  font-size: 8px;
  border-radius: 4px;
  width: 30px;
  height: 20px;
  min-width: 30px;
  min-height: 20px;
  margin-right: 2px;
}

.userFlg {
  margin-right: 4px;
}
</style>
